export default "__VITE_ASSET__Do8LbAZ7__"